export default {
    oauth: {
        url: 'https://oauth-abe.stage.pixellot.tv',
        clientId: 'cms-internal',
        redirectUrl: 'https://vpum-dev.pixellot.tv',
    },
};
